import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import SitePage from './pages/SitePage';
import IntakePage from './pages/IntakePage';
import ContentLibrary from './pages/ContentLibrary';
import PublishedContent from './pages/PublishedContent';
import StaffLogin from './pages/staff/StaffLogin';
import ContentDashboard from './pages/staff/ContentDashboard';
import ContentEditor from './pages/staff/ContentEditor';
import PrivatePreview from './pages/staff/PrivatePreview';
import EnquiryReports from './pages/staff/EnquiryReports';
import { StaffLayout } from './components/staff/StaffLayout';
import { StaffAuthProvider, StaffOnly } from './context/StaffAuth';
import { PublicContentProvider } from './context/PublicContent';
import './content.css';
import './App.css';

export default function App() {
  return (
    <BrowserRouter><PublicContentProvider>
      <Routes>
        <Route path="/intake" element={<IntakePage />} />
        <Route path="/blog" element={<ContentLibrary kind="article" />} />
        <Route path="/blog/:slug" element={<PublishedContent kind="article" />} />
        <Route path="/locations" element={<ContentLibrary kind="city" />} />
        <Route path="/locations/:slug" element={<PublishedContent kind="city" />} />
        <Route path="/staff/*" element={<StaffAuthProvider><Routes><Route path="login" element={<StaffLogin />} /><Route element={<StaffOnly><StaffLayout /></StaffOnly>}><Route index element={<ContentDashboard />} /><Route path="content/:id" element={<ContentEditor />} /><Route path="preview/:id" element={<PrivatePreview />} /><Route path="reports" element={<EnquiryReports />} /><Route path="*" element={<Navigate to="/staff" replace />} /></Route></Routes></StaffAuthProvider>} />
        <Route path="*" element={<SitePage />} />
      </Routes>
    </PublicContentProvider></BrowserRouter>
  );
}